export enum SettingType {
  Boolean = 1,
  Text = 2,
  Number = 3,
  Html = 4,
  Image = 5,
  Xls = 6,
}